import { IUpdateDetailsRequestData } from 'src/api/updateGlobalItemDetails/types';
import { IGlobalItem } from 'src/components/CreateGlobalItemWizard/types';
import { TGlobalItemKey } from '../getDirtyFields/getDirtyFields';

/**
 * Form request data for the payload of the endpoint that update global item details
 * the request data includes only the data that is changed and that is not an image
 * @param  {Array} Array of modified fields
 * @param  {Object} Object of all data coming from the form
 * @return {Object} Object of request data
 */

export const formUpdateGlobalItemRequestData = (
  dirtyFieldsKeys: TGlobalItemKey[],
  data: Partial<IGlobalItem>,
): IUpdateDetailsRequestData =>
  dirtyFieldsKeys.reduce(
    (acc: IUpdateDetailsRequestData, fieldName: TGlobalItemKey) =>
      fieldName === 'image'
        ? acc
        : {
            ...acc,
            [fieldName]: data[fieldName] || null,
          },
    {},
  );
